<template>
  <div class="order-wrapper">
    <div class="order-tips" v-if="isFestival">因春节快递停运，即日起暂停发货，2020年2月3日后恢复发货</div>
    <div class="order-tips" v-else>3个工作日内发货，购买订单后不可修改地址</div>
    <div class="address-wrapper" @click="editAddress">
      <div class="no-address" v-if="!hasAddress">请添加收货人信息</div>
      <div class="address-info" v-else>
        <div class="receiver">
          <div class="name">收件人：{{addressInfo.name}}</div>
          <div class="contact">{{addressInfo.contact}}</div>
        </div>
        <div class="address">收件地址：{{addressInfo.address}}</div>
      </div>
      <icon icon-class="navigation-arrow"></icon>
    </div>
    <div class="order-info">
      <div class="order-main-block">
        <div class="order-cover">
          <img src="/Application/Home/Resource/mini-program-static/book/cover-two-small.jpg" v-if="bookType == 1">
          <img src="/Application/Home/Resource/mini-program-static/book/cover-combo-small.jpg" v-if="bookType == 2">
          <img src="/Application/Home/Resource/mini-program-static/book/cover-one-small.jpg" v-if="bookType == 3">
        </div>
        <div class="order-main">
          <div class="title">《奇想·建筑》系列 1+2</div>
          <div class="sub-title">{{bookData[bookType - 1].title}}</div>
          <div class="price-box">
            <div class="price">¥ {{bookData[bookType - 1].salePrice}}</div>
            <div>×{{bookNum}}</div>
          </div>
        </div>
      </div>
      <div class="total">共计 <span>¥ {{bookPrice}}</span></div>
    </div>
    <div class="post-info">
      <div class="post-box">
        <div class="type">配送方式</div>
        <div class="content">包邮（限中国大陆地区）</div>
      </div>
      <div class="post-tips">
        <div>*本次活动仅限中国大陆地区</div>
        <div>其他地区的小伙伴请联系凯诺微信 Canopy2013</div>
      </div>
    </div>
    <div class="submit-order-wrapper">
      <div class="control-order-price">合计： <span>¥ {{totalPrice}}</span></div>
      <div class="submit"><button class="submit-button" :disabled="!hasAddress" @click="buy">立即购买</button></div>
    </div>

    <cano-dialog v-if="payDialogShow" :close-on-click-modal="false">
      <div class="pay-confirm">
        <h3>是否支付完成</h3>
        <div class="tips">
          <p>若已完成支付，请点击[支付完成]；</p>
          <p>若未完成支付或遇到问题，请点击[重新支付]</p>
        </div>
        <div class="confirm-control">
          <button class="control-button" @click="checkOrder">重新支付</button>
          <button class="control-button" @click="checkOrder">支付完成</button>
        </div>
      </div>
    </cano-dialog>
  </div>

</template>

<style lang="less" scoped>
  .order-wrapper{
    .order-tips{
      padding: 0 20px;
      background: #F85C5C;
      line-height: 24px;
      font-size: 12px;
      color: #fff;
    }
    .address-wrapper{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      height: 70px;
      .no-address{
        font-size: 16px;
        color: #999;
      }
      .address-info{
        width: 90%;
        .receiver{
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          line-height: 16px;
          color: #030303;
          font-weight: bold;
        }
        .address{
          font-size: 12px;
          line-height: 14px;
          margin-top: 8px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #666;
        }
      }
      svg{
        color: #999;
        font-size: 14px;
      }
    }
    .order-info{
      border-top: 12px solid #FAFAFA;
      padding: 20px 20px 0;
      .order-main-block{
        display: flex;
        justify-content: flex-start;
        border-bottom: 1px solid #F3F3F3;
        padding-bottom: 12px;
      }
      .order-cover{
        width: 64px;
        height: 64px;
        img{
          width: 100%;
        }
      }
      .order-main{
        box-sizing: border-box;
        width: calc(100% - 64px);
        padding-left: 12px;
        font-size: 14px;
        .title{
          font-weight: bold;
          font-size: 14px;
          color: #333;
          line-height: 14px;
        }
        .sub-title{
          margin-top: 8px;
          font-size: 12px;
          line-height: 12px;
          color: #666;
        }
        .price-box{
          margin-top: 12px;
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          line-height: 14px;
          color: #999;
        }
      }
      .total{
        height: 46px;
        line-height: 46px;
        text-align: right;
        font-size: 12px;
        color: #333;
        span{
          font-size: 14px;
          line-height: 14px;
          font-weight: bold;
          color: #F85C5C;
        }
      }
    }
    .post-info{
      border-top: 12px solid #FAFAFA;
      padding: 16px 20px;
      .post-box{
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        line-height: 12px;
        color: #333;
      }
      .post-tips{
        margin-top: 16px;
        padding-right: 8px;
        text-align: right;
        font-size: 10px;
        line-height: 24px;
        color: #999;
      }
    }
    .submit-order-wrapper{
      box-sizing: border-box;
      position: fixed;
      display: flex;
      justify-content: space-between;
      align-items: center;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 12px 20px;
      border-top: 1px solid #F3F3F3;
      .control-order-price{
        font-size: 16px;
        color: #333;
        span{
          color: @error;
        }
      }
      .submit{
        width: 130px;
        height: 44px;
        .submit-button{
          width: 100%;
          height: 44px;
          line-height: 44px;
          padding: 0;
          background: #4DA2C7;
          color: #FFF;
          border: 0;
          border-radius: 44px;
          font-size: 16px;
          box-sizing: 0 4px 10px 0 rgba(77, 162, 199, .3);
          transition: all .2s ease;
          &:active{
            opacity: .8;
          }
          &:disabled{
            background: #CCC;
          }
        }
      }
    }
    .pay-confirm{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 40px 20px 24px;
      h3{
        font-size: 20px;
        line-height: 20px;
        font-weight: bold;
        color: #333;
      }
      .tips{
        margin-top: 32px;
        font-size: 12px;
        color: #999;
        line-height: 20px;
      }
      .confirm-control{
        width: 100%;
        margin-top: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        .control-button{
          width: 80%;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid @cano;
          background: @cano;
          color: #FFF;
          font-size: 15px;
          border-radius: 40px;
          &:first-child{
            margin-right: 12px;
            background: transparent;
            color: @cano;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import canoDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        isFestival: false,
        bookType: null,
        hasAddress: false,
        bookNum: 1,
        bookPrice: '88.80',
        totalPrice: '93.80',
        addressInfo: {
          name: '',
          contact: '',
          address: '',
        },
        locationArr: [],
        detailAddress: '',
        paying: false,
        bookData: [{
          id: 1,
          title: '奇想·建筑',
          salePrice: '29.90',
          normalPrice: '118.00',
          thumb: '/pages/images/book/cover-two-small.jpg'
        }, {
          id: 2,
          title: '奇想系列 1+2',
          salePrice: '78.80',
          normalPrice: '197.00',
          thumb: '/pages/images/book/cover-combo-small.jpg'
        }, {
          id: 3,
          title: '奇想：建筑 景观 城市创意设计选集 1',
          salePrice: '58.80',
          normalPrice: '79.00',
          thumb: '/pages/images/book/cover-one-small.jpg'
        }],
        payDialogShow: false,
        payedOrderId: null,
      }
    },
    components: {
      canoDialog
    },
    created() {
      this.bookType = this.$route.query.type;
      this.bookNum = this.$route.query.num;

      let addressData = store.get('bookAddress');
      this.hasAddress = addressData ? true : false;
      if(this.hasAddress) {
        this.addressInfo = {
          name: addressData.name,
          contact: addressData.contact,
          address: `${addressData.region[0]}${addressData.region[1]}${addressData.region[2]}${addressData.detailAddress}`
        }
        this.locationArr = addressData.region;
        this.detailAddress = addressData.detailAddress;
        // store.remove('bookAddress')
      }

      this.bookPrice = parseFloat(this.bookNum * parseFloat(this.bookData[this.bookType - 1].salePrice)).toFixed(2);
      this.totalPrice = parseFloat(this.bookNum * parseFloat(this.bookData[this.bookType - 1].salePrice)).toFixed(2);

      // 获取JSSDK
      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/MobileBuy/get_jssdk', {
        url: url
      }).then(data => {
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ['chooseWXPay'],
        })
      })
    },
    mounted() {
      if(this.$route.query.oid) {
        this.payDialogShow = true;
        this.payedOrderId = this.$route.query.oid;
      }
    },
    methods: {
      // 编辑地址
      editAddress() {
        // 判断是否已有地址信息
        if(this.hasAddress) {
          store.set('bookAddress', {
            name: this.addressInfo.name,
            contact: this.addressInfo.contact,
            region: this.locationArr,
            detailAddress: this.detailAddress
          })
          this.$router.push('/book/editaddress');
        }else {
          this.$router.push('/book/editaddress');
        }
      },
      buy() {
        if(this.paying) return;
        this.paying = true;
        let orderId = '';
        this.$root.post('/MobileBuy/create_order', {
          name: this.addressInfo.name,
          mobile: this.addressInfo.contact,
          region: `${this.locationArr[0]}/${this.locationArr[1]}/${this.locationArr[2]}`,
          address: this.detailAddress,
          num: this.bookNum,
          type: this.bookType,
        }).then(data => {
          this.paying = false;
          console.log(data);
          if(data.status == 1) {
            // 保存订单号
            orderId = data.order_id;
            this.$root.post('/MobileBuy/payOrder', {
              order_id: data.order_id,
              openid: store.get('openid')
            }).then(res => {
              console.log(res);
              let _this = this;
              if(res.status == 1) {
                if(store.get('openid')) {
                  // 调用微信支付接口
                  wx.chooseWXPay({
                    timestamp: res.info.timeStamp,
                    nonceStr: res.info.nonceStr,
                    package: res.info.package,
                    signType: res.info.signType,
                    paySign: res.info.paySign,
                    success(result) {
                      if(result.errMsg == 'chooseWXPay:ok') {
                        _this.$router.push({path: '/book/success', query: {oid: res.info.oid}});
                      }else if(result.errMsg == 'chooseWXPay:cancel') {
                        _this.$notify('您已取消支付');
                      }else if(result.errMsg == 'chooseWXPay:fail') {
                        _this.$notify('支付出错，请稍后再试');
                      }
                    }
                  })
                }else {
                  // 调用H5支付跳转链接
                  let redirectUrl = encodeURIComponent(`${window.location.href}&oid=${orderId}`);
                  window.location.href = `${res.info.mweb_url}&redirect_url=${redirectUrl}`;
                }

              }else {
                this.$notify(res.msg);
              }
            })
          }else {
            this.$notify(data.msg);
          }
        })
      },
      checkOrder() {
        this.$root.post('/MobileBuy/check_order', {
          oid: this.payedOrderId
        }).then(data => {
          console.log(data);
          this.payDialogShow = false;
          if(data.status == 1) {
            this.$router.push({path: '/book/success', query: {oid: data.oid}});
          }else {
            this.$notify('订单未完成');
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Book/order.vue